export const getTarget = (openNewTab?: boolean) => {
  if (!openNewTab) {
    return {}
  }

  return { target: '_blank', rel: 'noopener noreferrer' }
}
